
(function roleDetailControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleDetailController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'adminRoleService', 'adminDocumentTypeService', 'auth', 'adminUserService', 'adminContainerTypeService','$filter', 
            function roleDetailController($scope, config, $state, $translate, $stateParams, errors, adminRoleService, adminDocumentTypeService, auth, adminUserService, adminContainerTypeService, $filter) {
                $scope.canAssociateAd = auth.isInRole('ROLES ASSOCIATE AD');
                $scope.allApps = auth.isInRole('CONFIG ADMIN APPS');                
                $scope.viewAudit = auth.isInRole('AUDIT READ');
                $scope.cancel = function () {
                    $state.go('role-find-preselect', { name: adminRoleService.getFilter().Name });
                };

                adminRoleService.getById($stateParams.id).then(function (result) {
                    $scope.role = result;
                    $scope.role.functions = $filter('orderBy')(result.functions, 'translatedName');                  
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                });

                adminDocumentTypeService.getRoleDocumentTypes($stateParams.id).then(function (documentTypes) {
                    $scope.documentTypes = documentTypes;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                });

                adminContainerTypeService.getRoleContainerTypes($stateParams.id).then(function (containerTypes) {
                    $scope.containerTypes = containerTypes;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                });

                adminUserService.getByRoleId(auth.getOrganizationId(), $stateParams.id).then(function (result) {
                    $scope.users = result.value;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                    });

                $scope.viewAuditHistory = function () {
                    var params = [];
                    params.push($scope.role.id);

                    $state.go('audit-history', {
                        entityName: "ROLE",
                        entityValues: params,
                        displayName: $scope.role.name,
                        organizationalUnitId: $scope.role.organizationalUnitId
                    });
                };
            }
        ]);
})();